import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const MENU_SCORECARD_ROUTES = new Set(['menuImprovements'])

export const checkMenuScorecardFeatureFlag: HermesGuardFn = async (to) => {
  if (!MENU_SCORECARD_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.menuScorecard')) {
    return {
      name: 'brand.home',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
